var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M10.743 1c3.73 0 .594 7.73-1.113 11.596-1.893 3.977-5.678 11.931-8.127 10.147s4.564-6.913 9.908-7.36c5.344-.445 12.622-1.03 11.467 2.008-1.156 3.038-5.233-.334-9.797-5.464C8.516 6.798 8.405 1 10.743 1Z"
  })));
};
export default SvgPdf;